import GeopointInput from './GeopointInput'
import GeopointSelect from './GeopointSelect'
import Pin from './Pin'
export default {
  GeopointInput,
  GeopointSelect,
  Pin,
}
